import { styled } from 'styled-components'
import { SelectFieldPrimitive } from '../fields/SelectField'

const WeedgetHeaderSelect: typeof SelectFieldPrimitive = styled(SelectFieldPrimitive)`
  margin: ${(p) => p.theme.spacings.none};
  & > div {
    border-width: ${(p) => p.theme.borderWidths.sm}px;
    height: 30px;
    padding-right: 0;
    & p {
      white-space: nowrap;
      font-weight: ${(p) => p.theme.typography.weights.medium};
      font-size: ${(p) => p.theme.typography.sizes.sm}px;
    }
    & > div {
      padding-right: ${(p) => p.theme.spacings.none}px;
      gap: ${(p) => p.theme.spacings.sm}px;

      & > div:nth-child(2) {
        //Masks vertical bar and padding
        & > div:first-child {
          display: none;
        }
        & > div:nth-child(2) {
          height: 100%;
          border-width: 0;
          &:hover {
            background-color: unset;
          }
        }
      }
    }
  }
`

export default WeedgetHeaderSelect
